import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-cd3",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-cd3.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-cd3.component.less",
})
export class PrefixCd3Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super({
      defaultValue: "00000",
      updateOn: "blur",
    });
    this.maxlength = 5;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["cd3"];
  }
}
